<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>设置</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">员工</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsSetSettle && !showIsDetails">
      <section class="searchBox">
        <div class="addStyle">
          <a-button v-show="!showIsSearch" @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button v-show="showIsSearch" @click="showIsSearch = false"
            >隐藏更多</a-button
          >
        </div>
        <div>
          <label>项目:</label>
          <a-select
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            style="width: 160px"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </div>
        <div v-show="showIsSearch">
          <label>门店/大仓/区域:</label>
          <a-select v-model="shop_id" style="width: 120px">
            <a-select-option
              v-for="(item, i) in shopsLIst"
              :key="i"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
        <div v-show="showIsSearch">
          <label>岗位:</label>
          <a-select
            v-model="role_id"
            mode="multiple"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            style="width: 160px"
          >
            <a-select-option
              v-for="(item, i) in roleList"
              :key="i"
              :value="item.id"
              >{{ item.role_name }}</a-select-option
            >
          </a-select>
        </div>
        <div v-show="showIsSearch">
          <label>计薪方式:</label>
          <a-radio-group v-model="guard_count_type">
            <a-radio :value="1">单价</a-radio>
            <a-radio :value="2">时薪</a-radio>
            <a-radio :value="3">底薪</a-radio>
          </a-radio-group>
        </div>
        <div>
          <label>字符串:</label>
          <a-input v-model="query_field" placeholder="请输入姓名/手机号" />
        </div>
        <div>
          <a-button style="margin-right: 10px" @click="clearSearch"
            >重置</a-button
          >
          <a-button
            style="margin-right: 10px"
            type="primary"
            icon="search"
            @click="onSearch"
            >搜索</a-button
          >
          <a-button @click="onDownload" class="resetStyle">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
        </div>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.user_name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.project_name }}</td>
              <td>{{ item.role_name }}</td>
              <td>{{ item.shop_name }}</td>
              <td>
                <span v-show="item.guard_config.guard_count_type == 1"
                  >单价</span
                >
                <span v-show="item.guard_config.guard_count_type == 2"
                  >时薪</span
                >
                <span v-show="item.guard_config.guard_count_type == 3"
                  >底薪</span
                >
                <span v-show="item.guard_config.guard_count_type == 4"
                  >计件</span
                >
              </td>
              <td>
                <span v-show="item.guard_config.guard_count_type == 1">{{
                  Number(item.guard_config.guard_price) + "元/单"
                }}</span>
                <span v-show="item.guard_config.guard_count_type == 2">{{
                  Number(item.guard_config.guard_time_price) + "元/小时"
                }}</span>
                <span v-show="item.guard_config.guard_count_type == 3">{{
                  Number(item.guard_config.guard_base_salary) + "元"
                }}</span>
                <span v-show="item.guard_config.guard_count_type == 4">{{
                  "底薪" +
                    Number(item.guard_config.guard_four_base_salary) +
                    "元 + " +
                    Number(item.guard_config.guard_four_price) +
                    "元/件"
                }}</span>
              </td>
              <td>
                <a style="color: #909399" @click="detailsPage(item)">详情</a>
                <a
                  style="color: #67c23a; margin-left: 20px"
                  @click="setSettlePage(item)"
                  >结算配置</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 结算配置 -->
    <setSettle
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
      v-show="showIsSetSettle"
    />
    <!-- 结算配置  end -->
    <!-- 详情 -->
    <workerDetails v-show="showIsDetails" :detailsVal="detailsVal" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import setSettle from "@/components/manpower/setSettle";
import workerDetails from "@/components/manpower/workerDetails";
export default {
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      query_field: "",
      editDetail: {},
      totalPage: Number,
      thList: [
        "姓名",
        "手机号码",
        "项目",
        "入职岗位",
        "所属门店/大仓/区域",
        "计薪方式",
        "结算价",
        "操作"
      ],
      project_id: "",
      proList: [],
      shopsLIst: [],
      shops_id: "",
      showIsSetSettle: false,
      detailsVal: {},
      showIsSearch: false,
      roleList: [],
      guard_count_type: "",
      role_id: [],
      shop_id: "",
      showIsDetails: false
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    setSettle,
    workerDetails
  },
  watch: {
    project_id() {
      this.getShops(this.project_id);
      this.getRole(this.project_id);
    }
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目列表
    this.getShops(); //获取门店
    this.getRole(); //获取岗位
  },
  methods: {
    detailsPage(val) {
      this.showIsDetails = true;
      this.detailsVal = val;
    },
    getRole() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url = this.httpsBasic.url + this.httpsBasic.user + "Role/lists";
      let params = {
        per_page: 100000,
        project_id: this.project_id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.roleList = res.data.data.data;
          // console.log(this.roleList);
        } else {
          this.$message.warning(res.data.message);
          this.loading = false;
        }
      });
    },
    setSettlePage(val) {
      this.showIsSetSettle = true;
      this.editDetail = val;
    },
    hideInEdit(msg) {
      this.showIsSetSettle = false;
      if (msg) {
        this.reload();
      }
    },
    showInUserList() {
      this.showIsSetSettle = false;
      this.showIsDetails = false;
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 5
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getShops() {
      this.shops_id = "";
      let url =
        this.httpsBasic.url + this.httpsBasic.people + "People_shop/lists";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: this.project_id,
          per_page: 10000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.shopsLIst = res.data.data.data;
            // console.log(this.shopsLIst);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChangeDate(date, dateString) {
      this.searchDate = dateString;
    },
    clearSearch() {
      this.query_field = "";
      this.project_id = "";
      this.guard_count_type = "";
      this.shop_id = "";
      this.role_id = [];
      this.page = 1;
      this.getData();
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    onDownload() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.people +
        "Guard/guardListDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&guard_count_type=" +
        this.guard_count_type +
        "&project_id=" +
        this.project_id +
        "&shop_id=" +
        this.shop_id +
        "&role_id=" +
        JSON.stringify(this.role_id);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.people + "Guard/guardList";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        guard_count_type: this.guard_count_type,
        token: window.localStorage.getItem("xnwfPcToken"),
        project_id: this.project_id,
        shop_id: this.shop_id,
        role_id: JSON.stringify(this.role_id)
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    > div {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      > label,
      > div,
      input {
        display: inline-block;
      }
      label {
        margin-right: 10px;
      }
      input {
        width: 200px;
      }
    }
  }
  .projectList {
    margin-bottom: 0;
    li {
      line-height: 20px;
      display: inline-block;
      > label,
      p,
      span {
        font-size: 14px;
        display: inline-block;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
